import IssueDetail from '@/components/linear/issue-detail';
import PageToolbar from '@/components/linear/page-toolbar';
import { issuesPath } from '@/lib/linear-paths';
import type { Issue } from '@/types/issue';
import { Link } from '@inertiajs/react';

interface Props {
  issue: Issue;
}

export default function Show({ issue }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar
        title={issue.identifier}
        tabs={
          <Link href={issuesPath()} className="ln-tab">
            All issues
          </Link>
        }
      />
      <div className="ln-page-scroll">
        <IssueDetail key={issue.id} issue={issue} />
      </div>
    </div>
  );
}
